import React from 'react'

const Loading = () => {
    return (
        <div className="loading relative w-20 h-20 rounded-full outline outline-8 outline-black before:absolute before:h-2 before:w-20 before:bg-black before:top-2/4 before:-translate-y-2/4 after:absolute after:w-[38px] after:h-[38px] after:rounded-full after:bg-white after:top-2/4 after:left-2/4 after:-translate-x-2/4 after:-translate-y-2/4"></div>
    )
}

export default Loading